import { palette } from '@openclassrooms/ui-web/theme';

// regexp from https://github.com/fancyapps/fancyBox/blob/master/source/helpers/jquery.fancybox-media.js
const mediaMatch = {
    youtube: {
      matcher:
        /(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*)).*/i,
      url: '//www.youtube.com/embed/$3',
      idsPosition: [3],
      idsPositionSeparator: '',
    },
    vimeo: {
      matcher: /(?:vimeo(?:pro)?.com)\/(?:[^\d]+)?(\d+)(?:.*)/,
      validationMatcher: /(?:vimeo(?:pro)?\.com)\/([0-9]+)/,
      url: `//player.vimeo.com/video/$1?color=${palette.brand.primary.substr(1)}`,
      idsPosition: [1],
      idsPositionSeparator: '',
    },
    dailymotion: {
      matcher: /dailymotion.com\/video\/(.*)\/?(.*)/,
      url: '//www.dailymotion.com/embed/video/$1',
      idsPosition: [1],
      idsPositionSeparator: '',
    },
    channel9: {
      matcher: /channel9\.msdn\.com\/(.*)\/(.*)#time=(.*)/,
      url: '//channel9.msdn.com/$1/$2/player#time=$3:paused',
      idsPosition: [1, 2],
      idsPositionSeparator: '/',
    },
  },
  MediaMatchService = {};

MediaMatchService.config = mediaMatch;

MediaMatchService.isValidVideoUrl = function (url) {
  const type = MediaMatchService.getTypeFromUrl(url);
  if (!type) {
    return false;
  }
  return Boolean(url.match(mediaMatch[type].validationMatcher || mediaMatch[type].matcher));
};

MediaMatchService.getTypeFromUrl = function (url) {
  var type;

  for (type in mediaMatch) {
    if (mediaMatch.hasOwnProperty(type) && url.match(mediaMatch[type].matcher)) {
      return type;
    }
  }
};

MediaMatchService.getIframeUrl = function (url) {
  const type = MediaMatchService.getTypeFromUrl(url);
  if (!type) {
    return null;
  }
  const cfg = MediaMatchService.config[type];
  const match = url.match(cfg.matcher);
  let iframeUrl = cfg.url;

  match.forEach(function (value, n) {
    iframeUrl = iframeUrl.replace('$' + n, value || '');
  });

  return iframeUrl;
};

/**
 * @param {string} url
 * @returns {string}
 */
MediaMatchService.getVideoIdFromUrl = function (url) {
  var urlType, matcher, idsPosition, idsPositionSeparator, parsedUrl, idSplitted, id;

  urlType = MediaMatchService.getTypeFromUrl(url);
  if (!urlType) {
    return null;
  }
  matcher = mediaMatch[urlType].matcher;
  idsPosition = mediaMatch[urlType].idsPosition;
  idsPositionSeparator = mediaMatch[urlType].idsPositionSeparator;
  parsedUrl = url.match(new RegExp(matcher));
  idSplitted = [];

  parsedUrl.forEach(function (urlPiece, index) {
    if (idsPosition.indexOf(index) !== -1) {
      idSplitted.push(urlPiece);
    }
  });

  id = idSplitted.join(idsPositionSeparator);

  return id;
};

export default MediaMatchService;
